import config from '../config';

export async function setSiteNotes(backend_fetch, siteId, rawData) {
    const f = await backend_fetch(config.REACT_APP_HOST + "/api/v2/notes/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(rawData)
    })
    return await f.json()
}